export const getProcedureName = procedure => {
	if (!procedure) {
		return '';
	}

	return procedure.name || procedure.Name || '';
};

export const formatProcedureName = procedure => {
	const name = getProcedureName(procedure);

	return name === '7mm' || name === '3mm' || name === '25mm'
		? `${name} PBM`
		: name;
};
